<template>
  <!-- Created -->
  <Message :id="ids.savedSuccessId" :text="savedText" :hidden="!initialVisible.saved" />

  <!-- Updated -->
  <Message :id="ids.updatedSuccessId" :text="updatedText" :hidden="!initialVisible.updated" />

  <!-- Deleted -->
  <Message :id="ids.removedSuccessId" :text="deletedText" :hidden="!initialVisible.deleted" />
</template>

<script>
import Message from "./Message.vue";

export default {
  name: "ConfirmMessages",
  components: { Message },
  props: {
    ids: {
      type: Object,
      required: true,
      validator(obj) {
        return (
          typeof obj.savedSuccessId === "string" &&
          typeof obj.updatedSuccessId === "string" &&
          typeof obj.removedSuccessId === "string"
        );
      },
    },
    texts: { type: Object, default: () => ({}) },
    initialVisible: { type: Object, default: () => ({ saved: false, updated: false, deleted: false }) },
  },
  computed: {
    savedText() {
      return this.texts.saved ?? this.$t("components.message_modal.saved");
    },
    updatedText() {
      return this.texts.updated ?? this.$t("components.message_modal.updated");
    },
    deletedText() {
      return this.texts.deleted ?? this.$t("components.message_modal.deleted");
    },
  },
};
</script>
